import { flatProjectTypeKeys } from '../view/constant/flatProjectTypeKeys';

export const isFlatProjectType = (projectTypeKey: string): boolean => {
  return flatProjectTypeKeys.includes(projectTypeKey);
};
